import React from 'react'

import RouteLayout from '../../RouteLayout'
import { Buttons, Form, Table } from './Components'
import Spinner from '../../common/Spinner'
import { useSelector } from 'react-redux'


export default function HiringPlan () {
  
  const { loader, form, data } = useSelector(state => state.reports.hiringPlan)
  
  return (
    <RouteLayout title={'Предложения по организации набора на вакантные места'}>
      <Form form={form}/>
      <Buttons visible={!!data?.length}/>
      {loader
        ? <Spinner />
        : <Table data={data}/>
      }
    </RouteLayout>
  )
}
